/* The message to show for a failed request: the server's own `error` when it
 * sent one, otherwise whatever the failure says about itself. */
export const errorText = (e) => e?.response?.data?.error || e?.message || String(e);
